import CookieConsent from 'react-cookie-consent'
import { ANALYTICS_EVENTS } from 'util/analyticsUtil'
import { track } from 'util/analyticsUtil'

export default function AnnoyingConsent() {
  return (
    <CookieConsent
      onAccept={() => track(ANALYTICS_EVENTS.CLOSE_CONSENT)}
    >
      This site uses "cookies" to provide personalization, support for purchases
      and usage analysis.
    </CookieConsent>
  )
}
